
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import MyCourse from './classroom/views/MyCourse/index.vue'
import MyStudy from './classroom/views/MyStudy/index.vue'
import MyAccount from './classroom/views/MyAccount/index.vue'
import MyCalendar from './classroom/views/MyCalendar/index.vue'
import Experience from './classroom/views/Experience/index.vue'
import Book from './classroom/views/Book/index.vue'
import HeaderUserPanel from './classroom/views/HeaderUserPanel/index.vue'
import StudyRecord from './classroom/views/StudyRecord/index.vue'

@Observer
@Component({
  components: {
    MyCourse,
    MyStudy,
    MyAccount,
    MyCalendar,
    Experience,
    StudyRecord,
    Book,
    HeaderUserPanel
  }
})
export default class MyClassroom extends Vue {
  get UserStore() {
    return this.$store.$storeUser
  }

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  init(): void {
    this.MyClassroomStore.fetchUserPanelData()
    this.MyClassroomStore.fetchStudyRecordData(this.UserStore.UserInfo.id)
    this.MyClassroomStore.LoadMyProductList()
    this.MyClassroomStore.LoadMyStudyData()
  }

  created(): void {
    this.init()
  }

  handleToSettings() {
    this.$router.push({
      path: `/myv2/settings`
    })
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.MyClassroomStore.reset()
  }
}
